import mixpanel from "mixpanel-browser";
import { useEffect, useRef } from "react";

import { useAccount } from "./use-account";
import { alert } from "../components/common/Alert";

declare global {
  interface Window {
    fbq: (action: string, event: string) => void;

    gtag: (...args: unknown[]) => void;
  }
}

export const useRespondToStripeCheckoutComplete = () => {
  const { refetchAccountDetails } = useAccount();
  const hasHandledCheckoutRef = useRef(false);
  // Hacky way to update the account context and navigate to the dashboard
  // after the user has successfully subscribed
  // Scoped here only because this is rendered everywhere relevant
  const searchParams = window.location.search;

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    if (
      params.get("checkoutComplete") === "true" &&
      !hasHandledCheckoutRef.current
    ) {
      hasHandledCheckoutRef.current = true;
      refetchAccountDetails();
      mixpanel.track("Upgrade Plan Success");
      window.fbq("track", "Purchase");
      window.gtag("event", "conversion");

      alert("success", "Upgrade Successful, you have great taste 🤩");
    }
  }, [searchParams, refetchAccountDetails]);
};
